import { TabNav } from '@/shared/components/TabNav';
import { useUrlFilters } from '@/shared/hooks/useUrlFilters';
import { JOB_TABS } from '../constants/tabConfig';
import { useJobTabCounts } from '../hooks/useJobTabCounts';

const FILTER_DEFAULTS = {
  tab: 'all',
  page: '1',
};

export function JobListTabs() {
  const [filters, setFilters] = useUrlFilters(FILTER_DEFAULTS);
  const { counts } = useJobTabCounts();

  const handleTabChange = (slug: string) => {
    setFilters({ tab: slug, page: '1' });
  };

  const tabs = JOB_TABS.map((tab) => ({
    id: tab.slug,
    label: tab.label,
    count: counts[tab.slug] ?? 0,
  }));

  return (
    <div className="overflow-x-auto">
      <TabNav tabs={tabs} activeTab={filters.tab} onTabChange={handleTabChange} variant="pill" />
    </div>
  );
}
